import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteNote = async (noteId: string): Promise<boolean> =>
  axios.delete(`/management/note/removenote?noteId=${noteId}`).then((res) => res?.data?.result)

type Props = {
  noteId: string
}

export const useManagementDeleteNote = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteNote'],
    mutationFn: ({ noteId }: Props) => deleteNote(noteId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted note.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete note, please try again.')
      }
    },
    throwOnError: false
  })
